<template>
 <div>
  <b-row>
    <b-col sm="3">
      <div class="text-window">
        <b-row>
          <b-col sm="12">
            <b-input v-model="freeWordFilter" @change="$emit('changeFreeWordFilter', $event)" size="sm" placeholder="フリーワード検索"/>
          </b-col>
        </b-row>
      </div>
    </b-col>
    <b-col sm="9">
    <div class="margin-left-4" style="display: inline-flex;">
      <button type="button" @click="$emit('outputCsv', $event)" class="btn btn-danger btn-sm">ファイル出力</button>
      <button type="button" @click="$emit('registerNewRecord', $event)" class="btn margin-left btn-primary btn-sm">新規レコード追加</button>
    </div>
  </b-row>
  <b-row class="component-margin-top-half">
    <b-col sm="2">
      <h6>表示件数: {{ recordCount }} 件</h6>
    </b-col>
  </b-row>
 </div>
</template>

<script>
import BaseComponent from '@/components/BaseComponent';

export default {
  mixins: [BaseComponent],
  props: {
    freeWordFilter: { default: ''},
    recordCount: { default: '0' }
  },
};
</script>
<style>
.component-margin-top-half {
  margin-top: 0.5rem;
}
.margin-left {
  margin-left: 1rem;
}
</style>